/* eslint-disable */

export interface UserAdministrationDetailsRoleDto {
  internalName: string;
  displayName: string;
  expiresAt: Date | null;
  isInherited: boolean;
}

export const fixUserAdministrationDetailsRoleDtoFromJson = (dto?: UserAdministrationDetailsRoleDto | null): void => {
  if (!dto) {
    return;
  }
  dto.expiresAt = dto.expiresAt && new Date(dto.expiresAt);
};

export const fixUserAdministrationDetailsRoleDtoToJson = (dto?: UserAdministrationDetailsRoleDto | null): void => {
  if (!dto) {
    return;
  }
};
